import dva from 'dva';
import '@babel/polyfill';
import history from './untils/history';
import './index.less';
const models = require('./models').default;

// 1. Initialize
const app = dva({
  history,
});
// 2. Plugins
// app.use({});

// 3. Model
models.map(model => {
  app.model(model);
});

// 4. Router
app.router(require('./router').default);

// 5. Start
app.start('#root');
